import { defineStore } from "pinia";

// Dashboard state interface
interface DashboardState {
  refreshTimestamp: number;
  currentView: string | null;
}

// Dashboard store
export const useDashboardStore = defineStore("dashboard", {
  state: (): DashboardState => ({
    refreshTimestamp: 0,
    currentView: null
  }),
  
  actions: {
    // Update the refresh timestamp for a specific view
    refreshView(view: string) {
      this.refreshTimestamp = Date.now();
      this.currentView = view;
    }
  }
});
